"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const asFloat_1 = __importDefault(require("../../Util/asFloat"));
const Unit_1 = require("../Unit");
class Nutrition {
    constructor(nutritionApi, nutritionCache, dateTimeBridge, calorieBudgetUtils, nutritionUtils) {
        this.zeroValueCalorieBudget = {
            calories: 0,
            carbohydrates: 0,
            fats: 0,
            proteins: 0,
            fibers: 0,
        };
        this.getNutritionProgressByDate = async (customerId, date) => {
            const inputDate = this.dateTimeBridge.systemDate(date);
            const result = (await this.nutritionCache.getDay(customerId, inputDate, async () => await this.nutritionApi.getNutritionProgressByDate(customerId, inputDate)));
            result.date = date;
            return result;
        };
        this.fetchNutritionProgressByDateRange = async (customerId, dateRange) => {
            return await this.nutritionCache.getDaysFromRange(customerId, dateRange, () => this.nutritionApi.fetchNutritionProgressByDateRange(customerId, dateRange));
        };
        this.fetchCalorieBudgetByDateRange = async (customerId, dateRange) => {
            try {
                const calorieBudgets = await this.nutritionCache.getCalorieBudgets(customerId, dateRange, () => this.nutritionApi.fetchCalorieBudgets(customerId, dateRange));
                const calorieBudget = this.calorieBudgetUtils.pickCalorieBudget(calorieBudgets, dateRange);
                return {
                    calorieBudget,
                };
            }
            catch (e) {
                return {
                    calorieBudget: {
                        forTrainingDay: this.zeroValueCalorieBudget,
                        forNonTrainingDay: this.zeroValueCalorieBudget,
                    },
                };
            }
        };
        this.calculateToG = (value) => (0, asFloat_1.default)(value * 28.3495231, 0);
        this.calculateCalories = async (carbohydrates, proteins, fats, unit) => {
            if (unit === Unit_1.Unit.IMPERIAL) {
                carbohydrates = this.calculateToG(carbohydrates);
                proteins = this.calculateToG(proteins);
                fats = this.calculateToG(fats);
            }
            return parseInt(fats * 9 + carbohydrates * 4 + proteins * 4 + "");
        };
        this.getAverageFactsForDayRange = (days, calorieBudget) => {
            return this.nutritionUtils.getAverageFactsForDayRange(days, calorieBudget);
        };
        this.nutritionApi = nutritionApi;
        this.nutritionCache = nutritionCache;
        this.dateTimeBridge = dateTimeBridge;
        this.calorieBudgetUtils = calorieBudgetUtils;
        this.nutritionUtils = nutritionUtils;
    }
}
exports.default = Nutrition;
//# sourceMappingURL=Nutrition.js.map